import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LoginPage } from "./components/LoginPage";
import { GamePage } from "./components/GamePage";
import { Layout } from "./Layout";
import { LoginSuccessPage } from "./components/LoginSuccessPage";
import { toast } from "wc-toast";
import { UserService } from "./services/UserService";
import { UserProvider } from "./UserProvider";

const userService = new UserService(
    process.env.REACT_APP_BACKEND_HOST || "https://tinypets.apps.heltweg.org/api"
);

export const UserServiceContext = React.createContext(userService);

ReactDOM.render(
    <React.StrictMode>
        <UserServiceContext.Provider value={userService}>
            <BrowserRouter basename={"/game"}>
                <UserProvider>
                    <Routes>
                        <Route path="/" element={<Layout />}>
                            <Route index element={<LoginPage />} />
                            <Route path="play" element={<GamePage />}></Route>
                            <Route
                                path="login/success"
                                element={<LoginSuccessPage />}
                            ></Route>
                        </Route>
                    </Routes>
                </UserProvider>
            </BrowserRouter>
        </UserServiceContext.Provider>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
    onSuccess: (registration: ServiceWorkerRegistration) => {
        toast.success("TinyPets has been saved for offline use.");
    },
    onUpdate: (registration: ServiceWorkerRegistration) => {
        toast.loading("New content available, reloading...", {
            duration: 4000,
        });
        if (registration.waiting) {
            registration.waiting.postMessage({ type: "SKIP_WAITING" });
            registration.waiting.addEventListener("statechange", (e: any) => {
                if (e.target.state === "activated") {
                    window.location.reload();
                }
            });
        }
    },
});
